import React from "react";
import Icon from "../Icon";

export const Loading = ({show, showSidebar}) => {
    return (
        <div className={`loading ${show ? 'show' : 'hide'} ${showSidebar ?? ''}`}>
            <Icon name="loading" size={32} className="spin" />
        </div>
    );
}

export default Loading;
